export default __webpack_public_path__ + "static/media/tvid.8b47049f.svg";